module.exports = __webpack_public_path__ + "static/media/Call-dark.9083d69c.svg";